// libs
import React, { memo } from 'react';

interface NykaaHomeProps {
  width?: number;
  height?: number;
  fill?: string;
  fillOpacity?: string;
  className?: string;
}

function NykaaHome({
  width = 24,
  height = 24,
  fill = '#001325',
  fillOpacity = '0.64',
  className = '',
}: NykaaHomeProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M20.78 3C21.44 1.72 19.3 2.09 19.3 2.09C18.52 2.09 18.18 3.02 18.02 3.29L15.7 7.83C15.26 8.58 13.83 11.83 13.35 12.54C13.35 11.82 13.35 10.36 13.35 10.01C13.44 8.62 13.54 7.58 13.68 6.31C13.8762 5.29862 13.9133 4.26282 13.79 3.24C13.66 2.63 13.46 2.59 12.59 2.5C11.72 2.41 11.05 3.74 10.75 4.36C9.65002 6.67 8.41002 8.93 7.41002 11.29C7.13002 11.98 6.76002 12.67 6.47002 13.35C6.12002 14.18 5.78002 14.99 5.39002 15.8C5.00002 16.61 3.70002 19.44 3.39002 20.31C3.08002 21.18 2.86002 22 4.46002 22C4.75335 22.0179 5.04664 21.9644 5.31483 21.8443C5.58301 21.7241 5.81811 21.5408 6.00002 21.31C6.45938 20.7365 6.79938 20.0769 7.00002 19.37C8.15002 16.5 8.94002 14.6 10.19 11.76C10.31 11.48 10.59 10.68 10.87 10.05C10.87 10.94 10.7 12 10.65 12.71C10.44 15.28 10.3 17.77 10.08 20.31C9.98493 20.6637 9.98493 21.0363 10.08 21.39C10.1814 21.5278 10.314 21.6395 10.467 21.716C10.62 21.7925 10.789 21.8316 10.96 21.83C12.23 21.98 12.36 21.35 12.76 20.47C13.16 19.59 13.33 19.05 13.65 18.26C14.65 15.8 15.65 13.37 16.8 10.98C17.09 10.38 17.38 9.77 17.7 9.17C18.28 8.07 18.76 7.04 19.39 5.82C19.86 4.91 20.32 3.93 20.82 2.96L20.78 3Z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </svg>
  );
}

export default memo(NykaaHome);
